import React from 'react'

export default function DarkTheme() {
  return (
    <section><a className="darkTheme" id="darkTheme"></a>
      <h2>Dark Theme</h2>

      <p>To utilise the Dark Theme varaints of dark grey and dark blue the HTML tag needs a <code>data-theme</code> data attribute added to it as follows</p>

      <p>HTML - Dark Grey</p>
      <pre><code className="language-html">{`<html lang="en" data-theme="dark">`}</code></pre>
      <br/>
      <p>HTML - Dark Blue</p>
      <pre><code className="language-html">{`<html lang="en" data-theme="dark-blue">`}</code></pre>
      <br/>
      <p>HTML - Default</p>
      <pre><code className="language-html">{`<html lang="en" data-theme="default">`}</code></pre>
      <br/>
      <p>This data-theme can be manipulated via JS</p>

      {/* <p>If a data-theme value is not specified, the theme will fall back to default unless the system preferences of the users system dictates that they want to use a dark theme, in this case the stlying associated with the Dark Grey <code>data-theme="dark"</code> will be applied</p> */}

      <br/><br/>
      <hr/>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/DarkTheme.js